import { SubState } from '../state';
import { AppState } from '../state.module';
import { StepGuard } from '../../core/model/step-guard';

export class DropshippingState implements SubState {
  constructor(
    private _parent: AppState = null,
    private _step: StepGuard = new StepGuard(),
    private _saleId: string = null,
    private _customerType: string = null,
    private _totalSale: number = null,

    private _totalToPayCent: number = null,
    private _brand: string = null,
    private _model: string = null,
    private _color: string = null,
    private _nmu: string = null,
    private _imei: string = null,
    private _kaskoId: string = null,
    private _customerId: string = null,
    private _shipmentType: boolean = false
  ) {}

  get parent(): AppState {
    return this._parent;
  }

  get step(): StepGuard {
    return this._step;
  }

  get saleId(): string {
    return this._saleId;
  }

  get customerType(): string {
    return this._customerType;
  }

  get totalSale(): number {
    return this._totalSale;
  }

  get totalToPayCent(): number {
    return this._totalToPayCent;
  }
  get brand(): string {
    return this._brand;
  }
  get model(): string {
    return this._model;
  }
  get color(): string {
    return this._color;
  }
  get nmu(): string {
    return this._nmu;
  }
  get imei(): string {
    return this._imei;
  }

  get kaskoId(): string {
    return this._kaskoId;
  }

  get customerId(): string {
    return this._customerId;
  }

  get shipmentType(): boolean {
    return this._shipmentType;
  }
  withParent(parent: AppState): DropshippingState {
    return new DropshippingState(
      parent,
      this._step,
      this._saleId,
      this.customerType,
      this.totalSale,
      this._totalToPayCent,
      this._brand,
      this._model,
      this._color,
      this._nmu,
      this._imei,
      this.kaskoId,
      this.customerId,
      this.shipmentType
    );
  }

  addCurrentWizzardStep(step: StepGuard): AppState {
    return this._parent.withDropshipping(
      this.recreate(
        step,
        this._saleId,
        this.customerType,
        this.totalSale,
        this._totalToPayCent,
        this._brand,
        this._model,
        this._color,
        this._nmu,
        this._imei,
        this.kaskoId,
        this.customerId,
         this.shipmentType
      )
    );
  }

  addDropshippingCustomerType(customerType: string): AppState {
    return this._parent.withDropshipping(
      this.recreate(
        this._step,
        this.saleId,
        customerType,
        this.totalSale,
        this.totalToPayCent,
        this.brand,
        this.model,
        this.color,
        this.nmu,
        this.imei,
        this.kaskoId,
        this.customerId,
        this.shipmentType
      )
    );
  }

  addDropshippingCustomerId(customerId: string): AppState {
    return this._parent.withDropshipping(
      this.recreate(
        this._step,
        this.saleId,
        customerId,
        this.totalSale,
        this.totalToPayCent,
        this.brand,
        this.model,
        this.color,
        this.nmu,
        this.imei,
        this.kaskoId,
        this.customerId,
        this.shipmentType
      )
    );
  }

  addPhoneInfo(
    saleId: string,
    totalToPayCent: number,
    brand: string,
    model: string,
    color: string,
    nmu: string,
    imei: string,
    kaskoId: string,
    customerId: string,
    shipmentType: boolean
  ): AppState {
    return this._parent.withDropshipping(
      this.recreate(
        this._step,
        saleId,
        this.customerType,
        this.totalSale,
        totalToPayCent,
        brand,
        model,
        color,
        nmu,
        imei,
        kaskoId,
        customerId,
        shipmentType
      )
    );
  }

  private recreate(
    step: StepGuard,
    saleId: string,
    customerType: string,
    totalSale: number,
    totalToPayCent: number,
    brand: string,
    model: string,
    color: string,
    nmu: string,
    imei: string,
    kaskoId: string,
    customerId: string,
    shipmentType: boolean
  ): DropshippingState {
    return new DropshippingState(
      null,
      step,
      saleId,
      customerType,
      totalSale,
      totalToPayCent,
      brand,
      model,
      color,
      nmu,
      imei,
      kaskoId,
      customerId,
      shipmentType
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/state/dropshipping/dropshipping-state.ts